export enum IntegrationInterfaceEnum {
  DownloadACESandPIES = 1,
  UploadACESandPIES = 2,
  PaquetExpressQuotation = 3,
  AcesPIESKey = 4,
  PaquetExpressGuia = 5,
  PaquetExpressCollectionOrder = 6,
  PaquetExpressPDF = 7,
  PaquetExpressZPL = 8,
  PaquetExpressReceiveTrackingUpdates = 10,
  PaquetExpressCancelGuia = 12,
  UploadPDF = 13,
  GetResults = 14,
  ReceiveQuote = 15,
  SendUpdates = 16,
  ImportQuote = 17,
  GeoapifyRouting = 19,
  PartsMappingPredict = 20,
  PartsMappingFeedback = 21,
  PartsMappingInventoryPredict = 22,
  PartsMappingInventoryFeedback = 23,
  XnuupApiKey = 24,
  GetSendUpdatesToken = 25,
  GoogleReCaptcha = 26,
  StripeCreateProduct = 27,
  StripeUpdateProduct = 28,
  StripeUpdatePrice = 29,
  StripeCheckout = 30,
  StripeWebhook = 31,
  StripeRefund = 32,
  SendOrdertoOracle = 33,
  SendPaintingToTheProductionLine = 34,
  ReceiveUpdateQuote = 35,
  ReceiveUpdateOrderPartStatus = 36,
  ProOrderGetImages = 37,
  GetSSO = 38,
  SendFlekkOrderUpdate = 39,
  PaymentVoucherID = 40,
  SISEReceiveClaimReport = 41,
  SISEReceiveSpeciaCondition = 42,
  SISEReceiveInvestigation = 43,
  GetTokenFromChoque = 44,
  SendValuationToChoque = 45,
  ReciveValuationFromChoque = 46,
  ReopenValuationFromChoque = 47,
  GetAvailableDocumentsFromQContent = 48,
  SendQContentfiles = 50,
  SendClaimUpdates = 51,
  GetFilesFromClaim = 52,
  GetPrintDocument = 53,
  CloseTask = 54,
  ReceiveComplement = 55,
  ReceivePartUpdates = 56,
  GetClaimDetails = 57,
  EAliciaCustomerSurvey = 58,
  PushNotificationBodyshopAssignedQMovil = 59,
  PushNotificationValuatorAssignedQMovil = 60,
  PushNotificationRepairCompletedQMovil = 61,
  PushNotificationValuationCompletedQMovil = 62,
  SendQuoteToXnuup = 63,
  SendDeliveredPartsQualitas = 64,
  GetClaimNotMigrated = 65,
  GetClaimNotMigratedDetails = 66,
  SendSavePortal = 67,
  GetClaimList = 68,
  UpdateVoucherStatusSISE = 69,
  SendClaimPartUpdates = 70,
  ReceiveClaimUpdates = 71,
  SearchDamagePayment = 72,
  ReceiveBanners = 73,
  AccessKeyWebhookBDEO = 74,
  GenerateUrlBDEO = 75,
  SetProviderSise = 76,
  UpdateValuationFromBDEO = 77,
  SendQuotesToFlekk = 78,
  SendQuotesToSupplier = 79,
  ReceiveAnswerFromSupplier = 80,
  CheckReassign = 81,
  CancelClaim = 82,
  GetClaimInformationFromATLAS = 83,
  LegalCRM = 84,
  CreateTask = 85,
  ReassignTask = 86,
  GetTask = 87,
  UpdateTaskAuthorize = 88,
  UpdateTaskComplement = 89,
  ReassignToBodyshop = 90,
  SearchNAGSCode = 91,
  ReceiveNewClaim = 92,
  CallbackApi = 93,
  GetVehicleData = 94,
  ReceiveVisitRegister = 105,
  PredictVehicleAndPartsBasedOnPhotos = 106
}
